import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=587f389b&scoped=true"
import script from "./pie.vue?vue&type=script&lang=js"
export * from "./pie.vue?vue&type=script&lang=js"
import style0 from "./pie.vue?vue&type=style&index=0&id=587f389b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587f389b",
  null
  
)

export default component.exports